(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $d7e6ba588081733d$var$t = function(t) {
    return Array.prototype.slice.call(t);
}, $d7e6ba588081733d$var$e = function() {
    var t = window.navigator.userAgent, e = !!t.match(/iPad/i) || !!t.match(/iPhone/i), i = !!t.match(/WebKit/i);
    return e && i && !t.match(/CriOS/i);
}, $d7e6ba588081733d$var$i = {
    scale: 1.5,
    speed: 1.5,
    wrapperClass: null,
    willChange: !1,
    externalRAF: !1
}, $d7e6ba588081733d$var$n = function(t, e) {
    var n = this;
    if (this.element = t, this.wrapper = document.createElement("div"), this.options = Object.assign({}, $d7e6ba588081733d$var$i, e), this.updateOptions(), this.vh = document.documentElement.clientHeight, this.isVisible = !1, this.damp = this.calcDamp(document.documentElement.clientWidth), this.elementTagName = t.tagName.toLowerCase(), "img" === this.elementTagName) {
        var r = t.getAttribute("src");
        if (!r) return;
        (async function(t) {
            var e = new Image;
            return e.src = t, await e.decode(), e;
        })(r).then(function() {
            n.createParallax();
        });
    } else this.createParallax();
};
$d7e6ba588081733d$var$n.prototype.createParallax = function() {
    this.setStyle(!0), this.wrapElement(), $d7e6ba588081733d$var$e() || this.createObserver();
}, $d7e6ba588081733d$var$n.prototype.updateOptions = function() {
    var t = this.element.getAttribute("data-u-scale"), e = this.element.getAttribute("data-u-speed"), i = this.element.getAttribute("data-u-willchange");
    null !== t && (this.options.scale = Number(t)), null !== e && (this.options.speed = Number(e)), null !== i && (this.options.willChange = !0);
}, $d7e6ba588081733d$var$n.prototype.setStyle = function(t) {
    void 0 === t && (t = !1);
    var e = this.element.clientHeight, i = this.element.clientWidth, n = window.getComputedStyle(this.element), r = "absolute" === n.position, o = this.wrapper.style, a = this.element.style, s = this.options.scale;
    r && "0px" !== n.marginRight && "0px" !== n.marginLeft && n.marginLeft === n.marginRight && (o.margin = "auto"), "0px" === n.marginTop && "0px" === n.marginBottom || (o.marginTop = n.marginTop, o.marginBottom = n.marginBottom, a.marginTop = "0", a.marginBottom = "0"), "auto" !== n.inset && (o.top = n.top, o.right = n.right, o.bottom = n.bottom, o.left = n.left, a.top = "0", a.right = "0", a.bottom = "0", a.left = "0"), "none" !== n.transform && (o.transform = n.transform), "auto" !== n.zIndex && (o.zIndex = n.zIndex), o.position = r ? "absolute" : "relative", "auto" !== n.gridArea && "auto / auto / auto / auto" !== n.gridArea && (o.gridArea = n.gridArea, a.gridArea = "auto"), t && (o.width = "100%", o.overflow = "hidden", a.display = "block", a.overflow = "hidden", a.backfaceVisibility = "hidden", "0px" !== n.padding && (a.padding = "0"), "img" === this.elementTagName ? a.objectFit = "cover" : "video" !== this.elementTagName && (a.backgroundPosition = "center")), "0px" !== n.borderRadius && (o.borderRadius = n.borderRadius, o.isolation || (o.isolation = "isolate"), "0px" !== n.marginLeft && (o.marginLeft = n.marginLeft, a.marginLeft = "0"), "0px" !== n.marginRight && (o.marginRight = n.marginRight, a.marginRight = "0"), o.width = i + "px"), r && (o.width = i + "px", a.width = "100%"), "none" !== n.maxHeight && (o.maxHeight = n.maxHeight, a.maxHeight = "none"), "0px" !== n.minHeight && (o.minHeight = n.minHeight, a.minHeight = "none"), a.width = i + "px", o.setProperty("height", e + "px", "important"), a.setProperty("height", e * s + "px", "important"), this.wrapperHeight = e, this.overflow = Math.floor(10 * (e - e * s)) / 10;
}, $d7e6ba588081733d$var$n.prototype.wrapElement = function() {
    var t = this.element.getAttribute("data-u-wrapper-class") || this.options.wrapperClass;
    t && this.wrapper.classList.add(t);
    var e = this.element.closest("picture"), i = null !== e ? e : this.element, n = i.parentNode;
    null !== n && n.insertBefore(this.wrapper, i), this.wrapper.appendChild(i);
}, $d7e6ba588081733d$var$n.prototype.checkVisible = function() {
    var t = this.wrapper.getBoundingClientRect();
    t.bottom > 0 && t.top < window.innerHeight ? this.onEnter() : this.onLeave();
}, $d7e6ba588081733d$var$n.prototype.createObserver = function() {
    var t = this;
    this.observer = new IntersectionObserver(function(e) {
        e[0].isIntersecting ? t.onEnter() : t.onLeave();
    }, {
        root: null,
        rootMargin: "0px",
        threshold: 0
    }), this.observer.observe(this.wrapper);
}, $d7e6ba588081733d$var$n.prototype.onEnter = function() {
    var t = this.element.style, e = "transform";
    this.options.willChange && t.willChange !== e && (t.willChange = e), this.isVisible = !0;
}, $d7e6ba588081733d$var$n.prototype.onLeave = function() {
    var t = this.element;
    this.options.willChange && "transform" === t.style.willChange && (t.style.willChange = ""), this.isVisible = !1;
}, $d7e6ba588081733d$var$n.prototype.calcTranslateValue = function() {
    var t = window.pageYOffset;
    t < 0 && (t = 0);
    var e = this.wrapper.getBoundingClientRect().top + t, i = (t + this.vh - e) / ((this.vh + this.wrapperHeight) / 100), n = Math.min(100, Math.max(0, i)) / 100, r = this.overflow, o = this.options.speed, a = (r * o - r) / 2, s = r * (1 - n) * o * this.damp - a;
    return Number(s.toFixed(4));
}, $d7e6ba588081733d$var$n.prototype.calcDamp = function(t) {
    var e = this.options.scale, i = this.options.speed;
    if (!(i >= 1.4 || e >= 1.4) || !(t <= 1e3)) return 1;
    e < 1 && (e = 1), i < 1 && (i = 1);
    var n = 1.2 - (1 - (t / 1e3 + (3 - (e + i)))), r = Math.max(.5, Math.min(1, n));
    return Math.floor(100 * r) / 100;
}, $d7e6ba588081733d$var$n.prototype.applyParallax = function() {
    this.element.style.transform = "translate3d(0 , " + this.calcTranslateValue() + "px , 0)";
}, $d7e6ba588081733d$var$n.prototype.animate = function() {
    $d7e6ba588081733d$var$e() && this.checkVisible(), window.pageYOffset < 0 || this.isVisible && this.applyParallax();
}, $d7e6ba588081733d$var$n.prototype.reset = function() {
    this.damp = this.calcDamp(window.innerWidth);
    var t = this.wrapper.style, e = this.element.style;
    this.vh = document.documentElement.clientHeight, t.width = "", t.position = "", t.height = "100%", e.width = "", "img" === this.elementTagName && "absolute" === t.position && (t.height = "100%"), "" === t.gridArea ? e.height = "" : e.height = "100%", "0px" !== t.margin && (t.margin = "", e.margin = ""), "auto" !== t.inset && (t.top = "", t.right = "", t.bottom = "", t.left = "", e.top = "", e.right = "", e.bottom = "", e.left = ""), "none" !== t.transform && (t.transform = "", e.transform = ""), "auto" !== t.zIndex && (t.zIndex = ""), "0px" !== t.borderRadius && (t.borderRadius = "", t.isolation = ""), this.setStyle(), this.applyParallax();
}, $d7e6ba588081733d$var$n.prototype.destroy = function() {
    var t;
    this.observer && this.observer.disconnect(), this.wrapper.removeAttribute("style"), this.element.removeAttribute("style"), (t = this.wrapper).replaceWith.apply(t, this.wrapper.childNodes);
};
var $d7e6ba588081733d$export$2e2bcd8739ae039 = function(e, i) {
    if (!e) throw new Error("Argument 'elements' cannot be null.");
    var n, r;
    this.instances = [], this.externalRAF = i && i.externalRAF || !1, this.onResizeEvent = this.resize.bind(this), n = "undefined" != typeof Promise && -1 !== Promise.toString().indexOf("[native code]"), r = "undefined" != typeof Element && Element.prototype.closest, n && r && "IntersectionObserver" in window && this.init(function(e) {
        return Array.isArray(e) ? e : "string" == typeof e ? $d7e6ba588081733d$var$t(document.querySelectorAll(e)) : e instanceof HTMLElement ? [
            e
        ] : e instanceof NodeList || e instanceof HTMLCollection ? $d7e6ba588081733d$var$t(e) : [
            e
        ];
    }(e), i);
};
$d7e6ba588081733d$export$2e2bcd8739ae039.prototype.init = function(t, e) {
    this.instances = t.map(function(t) {
        return new $d7e6ba588081733d$var$n(t, e);
    }), this.externalRAF || this.animate(), navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/) ? window.addEventListener("orientationchange", this.onResizeEvent) : window.addEventListener("resize", this.onResizeEvent);
}, $d7e6ba588081733d$export$2e2bcd8739ae039.prototype.animate = function() {
    this.instances.forEach(function(t) {
        t.animate();
    }), this.externalRAF || (this.requestId = window.requestAnimationFrame(this.animate.bind(this)));
}, $d7e6ba588081733d$export$2e2bcd8739ae039.prototype.reset = function() {
    this.instances.forEach(function(t) {
        t.reset();
    });
}, $d7e6ba588081733d$export$2e2bcd8739ae039.prototype.resize = function() {
    clearTimeout(this.timer), this.timer = window.setTimeout(this.reset.bind(this), 500), this.reset.bind(this);
}, $d7e6ba588081733d$export$2e2bcd8739ae039.prototype.destroy = function() {
    this.requestId && window.cancelAnimationFrame(this.requestId), window.removeEventListener("resize", this.onResizeEvent), window.removeEventListener("orientationchange", this.onResizeEvent), this.instances.forEach(function(t) {
        t.destroy();
    });
};


var $ce1ece6f96bcf313$exports = {};
!function(e, t) {
    $ce1ece6f96bcf313$exports = t();
}($ce1ece6f96bcf313$exports, function() {
    "use strict";
    var e = "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, t = "Expected a function", n = NaN, o = "[object Symbol]", i = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, c = /^0o[0-7]+$/i, s = parseInt, u = "object" == typeof e && e && e.Object === Object && e, d = "object" == typeof self && self && self.Object === Object && self, l = u || d || Function("return this")(), f = Object.prototype.toString, m = Math.max, p = Math.min, b = function() {
        return l.Date.now();
    };
    function v(e, n, o) {
        var i, a, r, c, s, u, d = 0, l = !1, f = !1, v = !0;
        if ("function" != typeof e) throw new TypeError(t);
        function y(t) {
            var n = i, o = a;
            return i = a = void 0, d = t, c = e.apply(o, n);
        }
        function h(e) {
            var t = e - u;
            return void 0 === u || t >= n || t < 0 || f && e - d >= r;
        }
        function k() {
            var e = b();
            if (h(e)) return x(e);
            s = setTimeout(k, function(e) {
                var t = n - (e - u);
                return f ? p(t, r - (e - d)) : t;
            }(e));
        }
        function x(e) {
            return s = void 0, v && i ? y(e) : (i = a = void 0, c);
        }
        function O() {
            var e = b(), t = h(e);
            if (i = arguments, a = this, u = e, t) {
                if (void 0 === s) return function(e) {
                    return d = e, s = setTimeout(k, n), l ? y(e) : c;
                }(u);
                if (f) return s = setTimeout(k, n), y(u);
            }
            return void 0 === s && (s = setTimeout(k, n)), c;
        }
        return n = w(n) || 0, g(o) && (l = !!o.leading, r = (f = "maxWait" in o) ? m(w(o.maxWait) || 0, n) : r, v = "trailing" in o ? !!o.trailing : v), O.cancel = function() {
            void 0 !== s && clearTimeout(s), d = 0, i = u = a = s = void 0;
        }, O.flush = function() {
            return void 0 === s ? c : x(b());
        }, O;
    }
    function g(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function w(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && f.call(e) == o;
        }(e)) return n;
        if (g(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = g(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, "");
        var u = r.test(e);
        return u || c.test(e) ? s(e.slice(2), u ? 2 : 8) : a.test(e) ? n : +e;
    }
    var y = function(e, n, o) {
        var i = !0, a = !0;
        if ("function" != typeof e) throw new TypeError(t);
        return g(o) && (i = "leading" in o ? !!o.leading : i, a = "trailing" in o ? !!o.trailing : a), v(e, n, {
            leading: i,
            maxWait: n,
            trailing: a
        });
    }, h = "Expected a function", k = NaN, x = "[object Symbol]", O = /^\s+|\s+$/g, j = /^[-+]0x[0-9a-f]+$/i, E = /^0b[01]+$/i, N = /^0o[0-7]+$/i, z = parseInt, C = "object" == typeof e && e && e.Object === Object && e, A = "object" == typeof self && self && self.Object === Object && self, q = C || A || Function("return this")(), L = Object.prototype.toString, T = Math.max, M = Math.min, S = function() {
        return q.Date.now();
    };
    function D(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function H(e) {
        if ("number" == typeof e) return e;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && L.call(e) == x;
        }(e)) return k;
        if (D(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = D(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(O, "");
        var n = E.test(e);
        return n || N.test(e) ? z(e.slice(2), n ? 2 : 8) : j.test(e) ? k : +e;
    }
    var $ = function(e, t, n) {
        var o, i, a, r, c, s, u = 0, d = !1, l = !1, f = !0;
        if ("function" != typeof e) throw new TypeError(h);
        function m(t) {
            var n = o, a = i;
            return o = i = void 0, u = t, r = e.apply(a, n);
        }
        function p(e) {
            var n = e - s;
            return void 0 === s || n >= t || n < 0 || l && e - u >= a;
        }
        function b() {
            var e = S();
            if (p(e)) return v(e);
            c = setTimeout(b, function(e) {
                var n = t - (e - s);
                return l ? M(n, a - (e - u)) : n;
            }(e));
        }
        function v(e) {
            return c = void 0, f && o ? m(e) : (o = i = void 0, r);
        }
        function g() {
            var e = S(), n = p(e);
            if (o = arguments, i = this, s = e, n) {
                if (void 0 === c) return function(e) {
                    return u = e, c = setTimeout(b, t), d ? m(e) : r;
                }(s);
                if (l) return c = setTimeout(b, t), m(s);
            }
            return void 0 === c && (c = setTimeout(b, t)), r;
        }
        return t = H(t) || 0, D(n) && (d = !!n.leading, a = (l = "maxWait" in n) ? T(H(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), g.cancel = function() {
            void 0 !== c && clearTimeout(c), u = 0, o = s = i = c = void 0;
        }, g.flush = function() {
            return void 0 === c ? r : v(S());
        }, g;
    }, W = function() {};
    function P(e) {
        e && e.forEach(function(e) {
            var t = Array.prototype.slice.call(e.addedNodes), n = Array.prototype.slice.call(e.removedNodes);
            if (function e(t) {
                var n = void 0, o = void 0;
                for(n = 0; n < t.length; n += 1){
                    if ((o = t[n]).dataset && o.dataset.aos) return !0;
                    if (o.children && e(o.children)) return !0;
                }
                return !1;
            }(t.concat(n))) return W();
        });
    }
    function Y() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    var _ = {
        isSupported: function() {
            return !!Y();
        },
        ready: function(e, t) {
            var n = window.document, o = new (Y())(P);
            W = t, o.observe(n.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0
            });
        }
    }, B = function(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, F = function() {
        function e(e, t) {
            for(var n = 0; n < t.length; n++){
                var o = t[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
            }
        }
        return function(t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
        };
    }(), I = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
    }, K = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, G = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, J = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, Q = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
    function R() {
        return navigator.userAgent || navigator.vendor || window.opera || "";
    }
    var U = new (function() {
        function e() {
            B(this, e);
        }
        return F(e, [
            {
                key: "phone",
                value: function() {
                    var e = R();
                    return !(!K.test(e) && !G.test(e.substr(0, 4)));
                }
            },
            {
                key: "mobile",
                value: function() {
                    var e = R();
                    return !(!J.test(e) && !Q.test(e.substr(0, 4)));
                }
            },
            {
                key: "tablet",
                value: function() {
                    return this.mobile() && !this.phone();
                }
            },
            {
                key: "ie11",
                value: function() {
                    return "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                }
            }
        ]), e;
    }()), V = function(e, t) {
        var n = void 0;
        return U.ie11() ? (n = document.createEvent("CustomEvent")).initCustomEvent(e, !0, !0, {
            detail: t
        }) : n = new CustomEvent(e, {
            detail: t
        }), document.dispatchEvent(n);
    }, X = function(e) {
        return e.forEach(function(e, t) {
            return function(e, t) {
                var n = e.options, o = e.position, i = e.node, a = (e.data, function() {
                    e.animated && (function(e, t) {
                        t && t.forEach(function(t) {
                            return e.classList.remove(t);
                        });
                    }(i, n.animatedClassNames), V("aos:out", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !1);
                });
                n.mirror && t >= o.out && !n.once ? a() : t >= o.in ? e.animated || (function(e, t) {
                    t && t.forEach(function(t) {
                        return e.classList.add(t);
                    });
                }(i, n.animatedClassNames), V("aos:in", i), e.options.id && V("aos:in:" + e.options.id, i), e.animated = !0) : e.animated && !n.once && a();
            }(e, window.pageYOffset);
        });
    }, Z = function(e) {
        for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
        return {
            top: n,
            left: t
        };
    }, ee = function(e, t, n) {
        var o = e.getAttribute("data-aos-" + t);
        if (void 0 !== o) {
            if ("true" === o) return !0;
            if ("false" === o) return !1;
        }
        return o || n;
    }, te = function(e, t) {
        return e.forEach(function(e, n) {
            var o = ee(e.node, "mirror", t.mirror), i = ee(e.node, "once", t.once), a = ee(e.node, "id"), r = t.useClassNames && e.node.getAttribute("data-aos"), c = [
                t.animatedClassName
            ].concat(r ? r.split(" ") : []).filter(function(e) {
                return "string" == typeof e;
            });
            t.initClassName && e.node.classList.add(t.initClassName), e.position = {
                in: function(e, t, n) {
                    var o = window.innerHeight, i = ee(e, "anchor"), a = ee(e, "anchor-placement"), r = Number(ee(e, "offset", a ? 0 : t)), c = a || n, s = e;
                    i && document.querySelectorAll(i) && (s = document.querySelectorAll(i)[0]);
                    var u = Z(s).top - o;
                    switch(c){
                        case "top-bottom":
                            break;
                        case "center-bottom":
                            u += s.offsetHeight / 2;
                            break;
                        case "bottom-bottom":
                            u += s.offsetHeight;
                            break;
                        case "top-center":
                            u += o / 2;
                            break;
                        case "center-center":
                            u += o / 2 + s.offsetHeight / 2;
                            break;
                        case "bottom-center":
                            u += o / 2 + s.offsetHeight;
                            break;
                        case "top-top":
                            u += o;
                            break;
                        case "bottom-top":
                            u += o + s.offsetHeight;
                            break;
                        case "center-top":
                            u += o + s.offsetHeight / 2;
                    }
                    return u + r;
                }(e.node, t.offset, t.anchorPlacement),
                out: o && function(e, t) {
                    window.innerHeight;
                    var n = ee(e, "anchor"), o = ee(e, "offset", t), i = e;
                    return n && document.querySelectorAll(n) && (i = document.querySelectorAll(n)[0]), Z(i).top + i.offsetHeight - o;
                }(e.node, t.offset)
            }, e.options = {
                once: i,
                mirror: o,
                animatedClassNames: c,
                id: a
            };
        }), e;
    }, ne = function() {
        var e = document.querySelectorAll("[data-aos]");
        return Array.prototype.map.call(e, function(e) {
            return {
                node: e
            };
        });
    }, oe = [], ie = !1, ae = {
        offset: 120,
        delay: 0,
        easing: "ease",
        duration: 400,
        disable: !1,
        once: !1,
        mirror: !1,
        anchorPlacement: "top-bottom",
        startEvent: "DOMContentLoaded",
        animatedClassName: "aos-animate",
        initClassName: "aos-init",
        useClassNames: !1,
        disableMutationObserver: !1,
        throttleDelay: 99,
        debounceDelay: 50
    }, re = function() {
        return document.all && !window.atob;
    }, ce = function() {
        arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (ie = !0), ie && (oe = te(oe, ae), X(oe), window.addEventListener("scroll", y(function() {
            X(oe, ae.once);
        }, ae.throttleDelay)));
    }, se = function() {
        if (oe = ne(), de(ae.disable) || re()) return ue();
        ce();
    }, ue = function() {
        oe.forEach(function(e, t) {
            e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay"), ae.initClassName && e.node.classList.remove(ae.initClassName), ae.animatedClassName && e.node.classList.remove(ae.animatedClassName);
        });
    }, de = function(e) {
        return !0 === e || "mobile" === e && U.mobile() || "phone" === e && U.phone() || "tablet" === e && U.tablet() || "function" == typeof e && !0 === e();
    };
    return {
        init: function(e) {
            return ae = I(ae, e), oe = ne(), ae.disableMutationObserver || _.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), ae.disableMutationObserver = !0), ae.disableMutationObserver || _.ready("[data-aos]", se), de(ae.disable) || re() ? ue() : (document.querySelector("body").setAttribute("data-aos-easing", ae.easing), document.querySelector("body").setAttribute("data-aos-duration", ae.duration), document.querySelector("body").setAttribute("data-aos-delay", ae.delay), -1 === [
                "DOMContentLoaded",
                "load"
            ].indexOf(ae.startEvent) ? document.addEventListener(ae.startEvent, function() {
                ce(!0);
            }) : window.addEventListener("load", function() {
                ce(!0);
            }), "DOMContentLoaded" === ae.startEvent && [
                "complete",
                "interactive"
            ].indexOf(document.readyState) > -1 && ce(!0), window.addEventListener("resize", $(ce, ae.debounceDelay, !0)), window.addEventListener("orientationchange", $(ce, ae.debounceDelay, !0)), oe);
        },
        refresh: ce,
        refreshHard: se
    };
});


var $2a94bc76f5a84eb5$exports = {};
/*!
 * purecounter.js - A simple yet configurable native javascript counter which you can count on.
 * Author: Stig Rex
 * Version: 1.5.0
 * Url: https://github.com/srexi/purecounterjs
 * License: MIT
 */ !function(e, t) {
    $2a94bc76f5a84eb5$exports = t();
}(self, function() {
    return function() {
        var e = {
            3: function(e, t, r) {
                "use strict";
                function n(e) {
                    return function(e) {
                        if (Array.isArray(e)) return i(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return i(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === r && e.constructor && (r = e.constructor.name);
                        if ("Map" === r || "Set" === r) return Array.from(e);
                        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i(e, t);
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function i(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function o(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function a(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                r.d(t, {
                    Z: function() {
                        return s;
                    }
                });
                var s = function() {
                    function e() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        o(this, e), this.defaults = {
                            start: 0,
                            end: 100,
                            duration: 2e3,
                            delay: 10,
                            once: !0,
                            pulse: !1,
                            decimals: 0,
                            legacy: !0,
                            filesizing: !1,
                            currency: !1,
                            separator: !1,
                            formater: "us-US",
                            selector: ".purecounter"
                        }, this.configOptions = this.setOptions(t, this.defaults), this.elements = document.querySelectorAll(this.configOptions.selector), this.intersectionSupport = this.intersectionListenerSupported(), this.registerEventListeners();
                    }
                    var t, r, i;
                    return t = e, r = [
                        {
                            key: "setOptions",
                            value: function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = {};
                                for(var n in e)if (0 === Object.keys(t).length || t.hasOwnProperty(n)) {
                                    var i = this.parseValue(e[n]);
                                    r[n] = i, n.match(/duration|pulse/) && (r[n] = "boolean" != typeof i ? 1e3 * i : i);
                                }
                                return Object.assign({}, t, r);
                            }
                        },
                        {
                            key: "registerEventListeners",
                            value: function() {
                                var e = this.elements;
                                if (0 !== e.length) {
                                    if (this.intersectionSupport) {
                                        var t = new IntersectionObserver(this.animateElements.bind(this), {
                                            root: null,
                                            rootMargin: "20px",
                                            threshold: .5
                                        });
                                        e.forEach(function(e) {
                                            t.observe(e);
                                        });
                                    } else window.addEventListener && (this.animateLegacy(e), window.addEventListener("scroll", function(t) {
                                        this.animateLegacy(e);
                                    }, {
                                        passive: !0
                                    }));
                                }
                            }
                        },
                        {
                            key: "animateLegacy",
                            value: function(e) {
                                var t = this;
                                e.forEach(function(e) {
                                    !0 === t.parseConfig(e).legacy && t.elementIsInView(e) && t.animateElements([
                                        e
                                    ]);
                                });
                            }
                        },
                        {
                            key: "animateElements",
                            value: function(e, t) {
                                var r = this;
                                e.forEach(function(e) {
                                    var n = e.target || e, i = r.parseConfig(n);
                                    if (i.duration <= 0) return n.innerHTML = r.formatNumber(i.end, i);
                                    if (!t && !r.elementIsInView(e) || t && e.intersectionRatio < .5) {
                                        var o = i.start > i.end ? i.end : i.start;
                                        return n.innerHTML = r.formatNumber(o, i);
                                    }
                                    setTimeout(function() {
                                        return r.startCounter(n, i);
                                    }, i.delay);
                                });
                            }
                        },
                        {
                            key: "startCounter",
                            value: function(e, t) {
                                var r = this, n = (t.end - t.start) / (t.duration / t.delay), i = "inc";
                                t.start > t.end && (i = "dec", n *= -1);
                                var o = this.parseValue(t.start);
                                e.innerHTML = this.formatNumber(o, t), !0 === t.once && e.setAttribute("data-purecounter-duration", 0);
                                var a = setInterval(function() {
                                    var s = r.nextNumber(o, n, i);
                                    e.innerHTML = r.formatNumber(s, t), ((o = s) >= t.end && "inc" === i || o <= t.end && "dec" === i) && (e.innerHTML = r.formatNumber(t.end, t), t.pulse && (e.setAttribute("data-purecounter-duration", 0), setTimeout(function() {
                                        e.setAttribute("data-purecounter-duration", t.duration / 1e3);
                                    }, t.pulse)), clearInterval(a));
                                }, t.delay);
                            }
                        },
                        {
                            key: "parseConfig",
                            value: function(e) {
                                var t = this, r = [].filter.call(e.attributes, function(e) {
                                    return /^data-purecounter-/.test(e.name);
                                }), i = 0 != r.length ? Object.assign.apply(Object, [
                                    {}
                                ].concat(n(r.map(function(e) {
                                    var r = e.name, n = e.value;
                                    return function(e, t, r) {
                                        return t in e ? Object.defineProperty(e, t, {
                                            value: r,
                                            enumerable: !0,
                                            configurable: !0,
                                            writable: !0
                                        }) : e[t] = r, e;
                                    }({}, r.replace("data-purecounter-", "").toLowerCase(), t.parseValue(n));
                                })))) : {};
                                return this.setOptions(i, this.configOptions);
                            }
                        },
                        {
                            key: "nextNumber",
                            value: function(e, t) {
                                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "inc";
                                return e = this.parseValue(e), t = this.parseValue(t), parseFloat("inc" === r ? e + t : e - t);
                            }
                        },
                        {
                            key: "convertNumber",
                            value: function(e, t) {
                                if (t.filesizing || t.currency) {
                                    e = Math.abs(Number(e));
                                    var r = 1e3, n = t.currency && "string" == typeof t.currency ? t.currency : "", i = t.decimals || 1, o = [
                                        "",
                                        "K",
                                        "M",
                                        "B",
                                        "T"
                                    ], a = "";
                                    t.filesizing && (r = 1024, o = [
                                        "bytes",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB"
                                    ]);
                                    for(var s = 4; s >= 0; s--)if (0 === s && (a = "".concat(e.toFixed(i), " ").concat(o[s])), e >= this.getFilesizeThreshold(r, s)) {
                                        a = "".concat((e / this.getFilesizeThreshold(r, s)).toFixed(i), " ").concat(o[s]);
                                        break;
                                    }
                                    return n + a;
                                }
                                return parseFloat(e);
                            }
                        },
                        {
                            key: "getFilesizeThreshold",
                            value: function(e, t) {
                                return Math.pow(e, t);
                            }
                        },
                        {
                            key: "applySeparator",
                            value: function(e, t) {
                                if (t.formater) {
                                    var r = t.separator ? "string" == typeof t.separator ? t.separator : "," : "";
                                    return "en-US" !== t.formater && !0 === t.separator ? e : (n = r, e.replace(/^(?:(\d{1,3},(?:\d{1,3},?)*)|(\d{1,3}\.(?:\d{1,3}\.?)*)|(\d{1,3}(?:\s\d{1,3})*))([\.,]?\d{0,2}?)$/gi, function(e, t, r, i, o) {
                                        var a = "", s = "";
                                        if (void 0 !== t ? (a = t.replace(new RegExp(/,/gi, "gi"), n), s = ",") : void 0 !== r ? a = r.replace(new RegExp(/\./gi, "gi"), n) : void 0 !== i && (a = i.replace(new RegExp(/ /gi, "gi"), n)), void 0 !== o) {
                                            var u = "," !== s && "," !== n ? "," : ".";
                                            a += o.replace(new RegExp(/\.|,/gi, "gi"), u);
                                        }
                                        return a;
                                    }));
                                }
                                var n;
                                return e;
                            }
                        },
                        {
                            key: "formatNumber",
                            value: function(e, t) {
                                var r = {
                                    minimumFractionDigits: t.decimals,
                                    maximumFractionDigits: t.decimals
                                }, n = "string" == typeof t.formater ? t.formater : void 0;
                                return e = this.convertNumber(e, t), e = t.formater ? e.toLocaleString(n, r) : parseInt(e).toString(), this.applySeparator(e, t);
                            }
                        },
                        {
                            key: "getLocaleSeparator",
                            value: function() {}
                        },
                        {
                            key: "parseValue",
                            value: function(e) {
                                return /^[0-9]+\.[0-9]+$/.test(e) ? parseFloat(e) : /^[0-9]+$/.test(e) ? parseInt(e) : /^true|false/i.test(e) ? /^true/i.test(e) : e;
                            }
                        },
                        {
                            key: "elementIsInView",
                            value: function(e) {
                                for(var t = e.offsetTop, r = e.offsetLeft, n = e.offsetWidth, i = e.offsetHeight; e.offsetParent;)t += (e = e.offsetParent).offsetTop, r += e.offsetLeft;
                                return t >= window.pageYOffset && r >= window.pageXOffset && t + i <= window.pageYOffset + window.innerHeight && r + n <= window.pageXOffset + window.innerWidth;
                            }
                        },
                        {
                            key: "intersectionListenerSupported",
                            value: function() {
                                return "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype;
                            }
                        }
                    ], r && a(t.prototype, r), i && a(t, i), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            634: function(e, t, r) {
                var n = r(3).Z;
                e.exports = n;
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                exports: {}
            };
            return e[n](o, o.exports, r), o.exports;
        }
        return r.d = function(e, t) {
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r(634);
    }();
}); //# sourceMappingURL=purecounter.js.map



const $403a34a0937c3dd7$var$block = document.querySelector(".expanded");
const $403a34a0937c3dd7$var$heading = document.querySelector(".expanded-heading");
const $403a34a0937c3dd7$var$expand = document.querySelector("#expand");
const $403a34a0937c3dd7$var$toAnimate = document.querySelector(".plus_vertical");
const $403a34a0937c3dd7$var$parallax = document.getElementsByClassName("ukiyo");
document.addEventListener("aos:in", ({ detail: detail })=>{
    console.log("animated in", detail);
});
document.addEventListener("aos:out", ({ detail: detail })=>{
    console.log("animated out", detail);
});
window.addEventListener("load", ()=>{
    // Code to run on page load
    if (window.innerWidth >= 1025) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ce1ece6f96bcf313$exports))).init();
        new (0, (/*@__PURE__*/$parcel$interopDefault($2a94bc76f5a84eb5$exports)))();
        new (0, $d7e6ba588081733d$export$2e2bcd8739ae039)($403a34a0937c3dd7$var$parallax, {
            scale: 2,
            speed: 2,
            willChange: true,
            wrapperClass: "ukiyo-wrapper",
            externalRAF: false
        });
    }
    $403a34a0937c3dd7$var$expand.addEventListener("click", ()=>{
        $403a34a0937c3dd7$var$toAnimate.classList.toggle("minus");
        $403a34a0937c3dd7$var$block.classList.toggle("d-none");
        $403a34a0937c3dd7$var$heading.classList.toggle("d-none");
        setTimeout(()=>{
            $403a34a0937c3dd7$var$block.classList.toggle("show");
            $403a34a0937c3dd7$var$heading.classList.toggle("show");
        }, 1);
    });
});
const $403a34a0937c3dd7$var$currURL = window.location.href;
if ($403a34a0937c3dd7$var$currURL === "https://stronghold-public.euwest01.umbraco.io/contact/" || $403a34a0937c3dd7$var$currURL === "https://stronghold.se/contact/") window.onload = function() {
    const styles = `
.container-block .bg-dotted-grid:has( > .half-width > .image-block) {
    background-repeat: space !important;
    padding: 195px 0;
    @media screen and (width <= 640px) {
    background: none !important;
    padding: 24px !important;
      }
  }
.body > main > div > div:nth-child(2) > div > div > div:nth-child(1) > div > div {
  box-shadow: 20px 0px 0px #fff;
}
`;
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
};
if ($403a34a0937c3dd7$var$currURL === "https://stronghold-public.euwest01.umbraco.io/our-journey/" || $403a34a0937c3dd7$var$currURL === "https://stronghold.se/our-journey/") window.onload = function() {
    const styles = `
    .container-block .bg-dotted-grid:has(.half-width>.cms-text-block.text-center.bg-white) {
      padding: 185px 0;
      .half-width .cms-text-block {
        padding: 10px 0;
      }
      @media screen and (max-width: 1513px) {
        background-repeat: space;
        padding: 195px 182px;
      }
      @media screen and (width <= 640px) {
        padding: 100px 0;
        margin-top: 13px;
        }
        @media screen and (width <= 431px) {
          padding: 90px 0;
          background-size: 100%;
          background-repeat: space;
        }
    }
  `;
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
};

})();
//# sourceMappingURL=index.js.map
